import React from "react";
import "./Notification.css";
import moment from "moment";

const NotificationBoxComponent = (props) => {
  var width = window.innerWidth;
  return (
    <React.Fragment>
      <div
        className={`d-flex justify-content-between align-items-center enNotificationBox
          ${props.data.readStatus ? "marked-as-read" : "marked-as-unread"}
        `}
        onClick={() =>
          props.localProps.onSingleClick(
            props.data,
            props.insidePageTab,
            props.insidePageText
          )
        }
        // style={{ backgroundColor: "#FFF3D8" }}
      >
        <div
        // onDoubleClick={() => props.localProps.onDoubleClick(props.data)}
        // onClick={
        //   width <= 1024
        //     ? () => {
        //         props.localProps.onSingleClick(props.data);
        //         props.localProps.onDoubleClick(props.data);
        //       }
        //     : () => props.localProps.onSingleClick(props.data)
        // }
        >
          <p className={`f12-700 text-red mb-2`}>
            {moment(props?.data && props?.data?.createdAt).format("DD/MM/YYYY")}
            , {moment(props?.data && props?.data?.createdAt).format("hh:mm A")}
          </p>
          <p className="m-0 f12-500">{props.data.content}</p>
          {props?.data?.comment !== undefined &&
          props?.data?.comment !== null ? (
            <p className="m-0 f12-500">Flag Comments: {props?.data?.comment}</p>
          ) : (
            <></>
          )}
        </div>
        <div
          className="enCloseNotification"
          onClick={() =>
            props.localProps.onClickRemove(
              props.data,
              props.insidePageTab,
              props.insidePageText
            )
          }
        >
          &times;
        </div>
      </div>
      {/* <div className="notification-box">
        <div
          className="notification-image"
          onDoubleClick={() => props.localProps.onDoubleClick(props.data)}
          onClick={
            width <= 1024
              ? () => {
                  props.localProps.onSingleClick(props.data);
                  props.localProps.onDoubleClick(props.data);
                }
              : () => props.localProps.onSingleClick(props.data)
          }
        >
          <Image
            src={
              props.data.serviceType === "RESERVATION"
                ? ReservationImage
                : props.data.isWalkIn === "true"
                ? WalkinImage
                : PendingImage
            }
            fluid
            alt="Reservation"
            title="Reservation"
          />
          <p
            className={
              props.data.readStatus ? "marked-as-read" : "marked-as-unread"
            }
          >
            {props.data.content}
          </p>
        </div>
        <div
          className="notification-box-relative"
          onClick={() => props.localProps.onClickRemove(props.data)}
        >
          &times;
        </div>
      </div> */}
    </React.Fragment>
  );
};

export default NotificationBoxComponent;
